<template>
  <div v-if="planner != null && ($store.state.user.id == planner.user_id || $store.state.user.role == 1)">

    <PageHeader v-bind:label="isUserThisPlanner ? 'Payment Settings' : planner.first_name + ' ' + planner.last_name + ' Payment Settings'"></PageHeader>
    
    <div class="my-8 text-base">
      
      <template v-if="$store.state.plannerModule.planner.freeAccess">
        You have been granted <span class="font-semibold">free access</span>.
      </template>

      <template v-else>

        <!-- IF the user has active subscription -->
        <template v-if="activeSubscription != null">

          <!-- COMING SOON: Switching plan -->
          <!-- <template v-if="plannerSubscription.active_package.id != plannerSubscription.latest_subscription_id">
            <div class="">
              You will continue to have access to all the features of
              <span class="font-semibold">{{ plannerSubscription.active_package.name }}</span>
              until
              <span class="font-semibold">{{ plannerSubscription.switch_date.date }}</span>
            </div>
          </template> -->

          <!-- <template v-else> -->
          <template>
            <!-- 
              Subscription has been cancelled, but user is on grace period eg canclled on 5th May but Subscription acutally 
              ends on 10th May. User still have 5 days remain with the subscription.
            -->
            <div v-if="activeSubscription.on_grace_period == true">
              You have cancelled your subscription <span class="font-semibold text-blue-500">{{ activeSubscription.name }}</span> plan. 
              Your subscription will end on
              <span class="font-semibold">{{ subscriptionEndDate }}</span>. You have full access to {{ getAppName }} until this date.
            </div>

            <div v-else>
              You are currently on
              <span class="font-semibold text-blue-500">{{ activeSubscription.name }}</span>
              subscription package.

              You can choose to 
              <a href="#" 
                class="text-red-500 underline" 
                v-on:click.prevent="cancelSubscription(activeSubscription)">cancel this subscription</a>.
<!--              or change to a different plan below.-->
            </div>
          </template>


        </template>

        <!-- if the user has NO active subscription -->
        <template v-else>
          <div class="text-base">
            You are currently not subscribed to any plan. Please select a plan below to get started.
          </div>
        </template>

        <div class="mt-12">
          <Subscriptions 
            v-bind:activeSubscription="activeSubscription"
            v-bind:plannerEmail="planner.email">
          </Subscriptions>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
  import Subscriptions  from './Subscriptions'
  import { EventBus }   from '@/shared/event-bus';
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import moment         from 'moment'

  export default {

    components: {
      PageHeader,
      Subscriptions
    },

    data () {
      return {
        planner            : null,
        activeSubscription : null
      }
    },

    computed: {
      subscriptionEndDate() {
        return moment(this.activeSubscription.ends_at, "YYYY-MM-DD").format("dddd, MMMM Do YYYY")
      }
    },

    mounted() {
      EventBus.$on('get-subscription', () => {
        this.getPlannerDetail();
      });
    },

    created() {    
      this.getPlannerDetail();
    },

    methods : {

      getPlannerDetail() {
        this.showLoader("Getting data...")
        this.getPlanner({
            plannerId: this.$route.params.plannerId,
          }, (planner) => {
            this.planner = planner            
        })

        if (!this.$store.state[this.$store.state.view + 'Module'].planner.freeAccess) {        
          this.getActiveSubscription();
        }
        this.hideLoader();
      },

      getActiveSubscription() {
        this.apiGet({}, 'subscription/active', (data) => {
          if (!(data instanceof Array)) {
            this.activeSubscription = data;
          }          
        })
      },

      cancelSubscription() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: `Are you sure you want to cancel your ${this.activeSubscription.name} package?`,
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiPost({
                planName: this.activeSubscription.name
              }, 'plan/cancel', () => {
                this.$modal.hide('confirm-modal')
                EventBus.$emit('get-subscription')
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': 'Successfully cancelled.'
                })
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    }
  }
</script>